// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"_1jjhc882sqjh","footer":"_1l_EafReDQV8","footer__button":"gUMgADkDgI5f"};